import { render, staticRenderFns } from "./CampaignsChartsPlacement.component.vue?vue&type=template&id=422cec9c&scoped=true&"
import script from "./CampaignsChartsPlacement.component.vue?vue&type=script&lang=js&"
export * from "./CampaignsChartsPlacement.component.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsChartsPlacement.component.vue?vue&type=style&index=0&id=422cec9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422cec9c",
  null
  
)

export default component.exports